<template>
  <div>
    <router-view />
    <index-card v-show="$route.name === 'Regions'" :loading="false">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact>
            <v-icon class="white--text">mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            v-if="user_can_edit"
            color="white"
            class="ml-1 blue-grey--text elevation-0 font-weight-bold"
            @click="openCreateCountry"
          >
            <v-icon small left>mdi-plus</v-icon>
            Adicionar país
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">Regiões</span>
          <v-btn text icon class="ml-1" @click="refreshTree">
            <v-icon class="white--text">mdi-refresh</v-icon>
          </v-btn>
        </div>
      </template>

      <template slot="subheader">
        <div class="regions-filter-full-width">
          <filter-data
            with_text_search
            text_search_label="Pesquisar por nome da região"
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>

      <template slot="data_table">
        <region-nested-table
          :parent-id="null"
          :depth="0"
          :search="applied_search_filter"
          :global-search="Boolean(applied_search_filter)"
          :user-can-edit="user_can_edit"
          :refresh-counter="tree_refresh_counter"
          @edit="openEdit"
          @delete="removeRegion"
          @add-child="openCreateChild"
        />
      </template>
    </index-card>

    <region-form-dialog
      :value="form_dialog"
      :region-id="editing_region_id"
      :initial-parent-id="child_parent_id"
      :initial-kind="child_kind"
      @saved="onRegionSaved"
      @input="onFormDialogInput"
    />
  </div>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'Regions',
  components: {
    IndexCard: () => import('@/_backoffice/_registrations/components/shared/index/IndexCard.vue'),
    RegionNestedTable: () => import('./RegionNestedTable.vue'),
    RegionFormDialog: () => import('./RegionFormDialog.vue'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      applied_search_filter: '',
      tree_refresh_counter: 0,
      form_dialog: false,
      editing_region_id: null,
      child_parent_id: null,
      child_kind: null,
    }
  },
  computed: {
    user_can_edit() {
      return ['Director', 'Manager'].includes(this.current_user_role_name)
    },
  },
  methods: {
    handleDoneFilter(filter_payload = {}) {
      this.applied_search_filter = String(filter_payload.query || '').trim()
    },
    refreshTree() {
      this.tree_refresh_counter += 1
    },
    onRegionSaved() {
      this.refreshTree()
    },
    onFormDialogInput(open) {
      this.form_dialog = open
      if (!open) {
        this.editing_region_id = null
        this.child_parent_id = null
        this.child_kind = null
      }
    },
    openCreateCountry() {
      this.editing_region_id = null
      this.child_parent_id = null
      this.child_kind = 'country'
      this.form_dialog = true
    },
    nextKindByParent(kind) {
      let kind_hierarchy = ['country', 'state', 'rgint', 'rgi', 'city', 'regional', 'neighborhood']
      let kind_index = kind_hierarchy.indexOf(kind)
      if (kind_index === -1) return 'city'
      if (kind_index === kind_hierarchy.length - 1) return kind
      return kind_hierarchy[kind_index + 1]
    },
    openCreateChild(row) {
      this.editing_region_id = null
      this.child_parent_id = Number(row.id)
      this.child_kind = this.nextKindByParent(row.kind)
      this.form_dialog = true
    },
    openEdit(row) {
      this.editing_region_id = row.id
      this.form_dialog = true
    },
    removeRegion(item) {
      this.swallConfirmation({
        title: `Excluir a região "${item.name}"?`,
        text: 'Esta ação não pode ser desfeita.',
        icon: 'warning',
      }).then((ok) => {
        if (!ok) return
        Api.Region.delete(item.id)
          .then(() => {
            this.successDeleted()
            this.refreshTree()
          })
          .catch(() => {
            this.addNotification({
              type: 'error',
              msg: 'Não foi possível excluir (verifique vínculos ou sub-regiões).',
            })
          })
      })
    },
  },
}
</script>

<style scoped>
.regions-filter-full-width {
  width: 100%;
}

.regions-filter-full-width >>> .filter-data-card {
  width: 100%;
}
</style>
